export function Crop(landmarks) {
  if (!landmarks?.length) return landmarks;

  let minX = Infinity, minY = Infinity;
  let maxX = -Infinity, maxY = -Infinity;

  for (const p of landmarks) {
    if (p.x < minX) minX = p.x;
    if (p.y < minY) minY = p.y;
    if (p.x > maxX) maxX = p.x;
    if (p.y > maxY) maxY = p.y;
  }

  const width = maxX - minX;
  const height = maxY - minY;

  const size = Math.max(width, height);

  const nose = landmarks[1];
  const leftEye = landmarks[33];
  const rightEye = landmarks[263];

  const eyeMidX = (leftEye.x + rightEye.x) * 0.5;
  const eyeMidY = (leftEye.y + rightEye.y) * 0.5;

  const centerX = (eyeMidX + nose.x) * 0.5;
  const centerY = (eyeMidY + nose.y) * 0.5;

  const croppedLandmarks = landmarks.map((p) => {
    return {
      x: p.x-centerX,
      y: p.y-centerY,
      z: p.z / size,
    };
  });

  return croppedLandmarks;
}

export default Crop;